/**
 * Gets text from text object
 * Returns the first available value
 * 
 * @param textObject - Object with language codes as keys and text as values
 * @param fallback - Default text if no translation found
 * @returns Text string
 */
export const getLocalizedText = (
  textObject: { [key: string]: string } | undefined,
  fallback = ""
): string => {
  if (!textObject) return fallback
  
  // Return the first available value
  const firstValue = Object.values(textObject)[0]
  return firstValue || fallback
}